<template>
	<div>
		<TitleSection>
			<template #h1>
				Werde Teil der Zukunft
			</template>
			<template #h2>
				Wir suchen Köpfe, die in Code denken.
			</template>
		</TitleSection>
		<NuxtLayout name="slider">
			<SingleSection>
				<div class="text-info">
					Aktuell haben wir keine offenen Stellen zu besetzen.
				</div>
			</SingleSection>
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Jobs',
	ogTitle: 'Jobs: Mailuft',
	twitterTitle: 'Jobs: Mailuft',
	ogDescription: 'Gestalten Sie mit uns die Zukunft der IT! Finden Sie unsere aktuellen Jobs in Wien. Wir suchen Talente, die unsere Mission mit Leidenschaft verfolgen.',
	description: 'Gestalten Sie mit uns die Zukunft der IT! Finden Sie unsere aktuellen Jobs in Wien. Wir suchen Talente, die unsere Mission mit Leidenschaft verfolgen.',
	twitterDescription: 'Gestalten Sie mit uns die Zukunft der IT! Finden Sie unsere aktuellen Jobs in Wien. Wir suchen Talente, die unsere Mission mit Leidenschaft verfolgen.',
})

definePageMeta({
	layout: 'slider',
})
</script>